import * as corePixiInit from './core/initializePixi.js'

const loadAndExecuteFunction = (func) => (...args) =>
  corePixiInit.loadGameUIFunctions()
    .then((gameUI) => gameUI[func](...args))
    .catch((error) => {
      throw error
    })

const resetPixiGame = loadAndExecuteFunction('resetPixiGame')

export const pixiAppResize = (x, y) => {
  corePixiInit.resizePixiApp(x, y)
  resetPixiGame(x, y)
}

export const tuktukApplicationInit = (pixiStates) => corePixiInit.init(pixiStates)

export const tuktukAssetsLoad = (pixiStates) => corePixiInit.loadPixiAssets(pixiStates)

export const tuktukAplicationDestroy = () => corePixiInit.destroyPixiApp()

export const isSimulate = false


// const assetsLoadDiv = document.createElement('button')
// assetsLoadDiv.innerHTML = 'Load Assets'
// assetsLoadDiv.onclick = () => pixiAssetsLoad()
// document.body.appendChild(assetsLoadDiv)

// const createPixiDiv = document.createElement('button')
// createPixiDiv.innerHTML = 'Create Pixi'
// createPixiDiv.onclick = () => pixiApplicationInit()
// document.body.appendChild(createPixiDiv)

// const destroyPiixDiv = document.createElement('button')
// destroyPiixDiv.innerHTML = 'Destyoy Pixi'
// destroyPiixDiv.onclick = () => pixiApplicationDestroy()
// document.body.appendChild(destroyPiixDiv)

// const changeCauldronAnimationDiv = document.createElement('button')
// changeCauldronAnimationDiv.innerHTML = 'start'
// changeCauldronAnimationDiv.onclick = () => changeCauldronAnimation()
// document.body.appendChild(changeCauldronAnimationDiv)

// const stopCauldronAnimationDiv = document.createElement('button')
// stopCauldronAnimationDiv.innerHTML = 'stop'
// stopCauldronAnimationDiv.onclick = () => stopCauldronAnimation()
// document.body.appendChild(stopCauldronAnimationDiv)

// const changeCauldronEffectsDiv = document.createElement('button')
// changeCauldronEffectsDiv.innerHTML = 'Flame'
// changeCauldronEffectsDiv.onclick = () => changeCauldronEffects(2)
// document.body.appendChild(changeCauldronEffectsDiv)
